<template>
  <div class="flex flex_col task-page">
    <!-- 上面的选择 -->
    <div class="selects">
      <el-form
        :model="queryParam"
        ref="ruleform"
        :inline="true"
        class="flex flex_ju_sb warnform-inline"
      >
        <div class="form-inputs">
          <el-form-item
            label="区域名称"
            style="margin-right: 10px"
            v-if="isShowAllSelect"
          >
            <!-- <el-input v-model="queryParam.orgName" maxlength="10" placeholder="请输入"></el-input> -->
            <el-select
              v-model="allOrgId"
              :placeholder="orgAllSelect.length ? '请选择' : '暂无数据'"
              @change="changeAllOrg"
            >
              <el-option
                v-for="(item, index) in orgAllSelect"
                :key="index"
                :value="item.orgId"
                :label="item.orgName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="isShowAllSelect ? '' : '区域名称'"
            :class="{ 'form-item-had': isShowAllSelect }"
          >
            <el-select
              v-model="queryParam.orgId"
              :placeholder="orgSelect.length ? '请选择' : '暂无数据'"
              @change="changeOrg"
            >
              <el-option
                v-for="(item, index) in orgSelect"
                :key="index"
                :value="item.orgId"
                :label="item.orgName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务名称">
            <el-input
              v-model="queryParam.taskName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="选择时间" class="form-picker">
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.startTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions0"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>

            <span class="pick-word">至</span>
            <div class="picker-divs">
              <el-date-picker
                v-model="queryParam.endTime"
                size="small"
                type="date"
                placeholder="选择日期"
                popper-class="pick-poper"
                class="picker-div"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                prefix-icon=" "
                clear-icon="el-icon-date"
                :clearable="false"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
              <i class="pick-icon el-icon-date"></i>
            </div>
          </el-form-item>
        </div>

        <el-form-item class="form-btns">
          <el-button type="primary" @click="searchClick">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 下面的表格 -->
    <div class="flex flex_col warn-tables">
      <!-- 列表切换tab -->
      <div class="btn-switchs">
        <div
          class="btn-switch-btn"
          :class="{ 'btn-switch-active': tabIndex == 0 }"
          @click="changeTab(0)"
        >
          任务操作
        </div>
        <div
          class="btn-switch-btn"
          :class="{ 'btn-switch-active': tabIndex == 1 }"
          @click="changeTab(1)"
        >
          历史记录
        </div>
        <div class="bgs" :style="bgsStyle"></div>
      </div>
      <!-- 表格 -->
      <el-table
        :data="tableData"
        class="tables"
        :height="535"
        :stripe="true"
        align="center"
        header-cell-class-name="header-cell"
        cell-class-name="table-cell"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="150" align="center">
        </el-table-column>
        <el-table-column
          prop="taskName"
          label="任务名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column prop="orgName" label="区域名称" align="center" show-overflow-tooltip> </el-table-column> -->
        <el-table-column label="开始时间" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="tabIndex == 0">{{ scope.row.startTime }}</span>
            <span v-if="tabIndex == 1">{{ scope.row.startTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束时间" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="tabIndex == 0">{{ scope.row.finishTime }}</span>
            <span v-if="tabIndex == 1">{{ scope.row.finishTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="finishStateName"
          label="任务状态"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" align="center" v-if="tabIndex == 0">
          <template slot-scope="scope">
            <span class="table-edit" @click="handleEnd(scope.row)">完成</span>
            <span class="table-del" @click="handleCancel(scope.row)">取消</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
					v-else-if="tabIndex == 1"
					prop="setTime"
					label="操作时间"
					align="center"
					show-overflow-tooltip
				>
				</el-table-column> -->
        <!-- 占位数据 -->
        <div slot="empty" class="table-empty">
          <img
            class="table-noimg"
            src="@/assets/image/home/img_none.png"
            alt=""
          />
          <div class="table-emptyword">暂无数据</div>
        </div>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination"
        layout="prev, pager, next"
        :current-page.sync="ipagination.currentPage"
        :page-size="ipagination.pageSize"
        :total="ipagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * @description 任务管理页面
 */
import tableMinin from "@/mixins/TableMinin";
export default {
  mixins: [tableMinin],
  data() {
    const self = this;
    return {
      orgAllSelect: [], // 生产区域下拉选
      allOrgId: "", /// 分公司下面选中的orgid
      // 上面的监测站点选择表单
      orgSelect: [], // 上面的下拉选数据
      // 表格数据

      tableData: [],
      tabIndex: 0, // tab选中值，用于任务操作和历史记录的切换
      isTranPage: true,
      isFillTime: true,
      // 接口
      url: {
        taskList: self.$api.taskSetTableList,
        hisList: self.$api.taskHisTableList,
      },
      orgName: "",
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.queryParam.endTime) {
            if (this.queryParam.endTime != "") {
              let num = new Date(this.queryParam.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum =
              new Date(this.queryParam.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
    };
  },
  computed: {
    bgsStyle() {
      let params = {
        left: 0,
      };
      if (this.tabIndex == 0) {
        params = {
          left: 0,
        };
      } else {
        params = {
          left: "50%",
        };
      }
      return params;
    },
  },
  mounted() {
    // 获取生产区域下拉选
    // this.getOrgids()
    // 获取任务操作列表
    // this.getSetTableList()
    // 获取历史记录列表
    // this.getHisTableList()
    if (this.isShowAllSelect) {
      // 获取上面的生产区域信息
      this.getAllOrgids();
    } else {
      this.getOrgids();
    }
  },
  methods: {
    /**
     * @param isFen 是否是分公司账号
     * @param isRequest  是否请求列表数据
     */
    // 获取生产区域下拉选
    getOrgids(isFen = false, isRequest = true) {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        parentOrgId: "",
        type: "3",
      };
      if (isFen) {
        params.parentOrgId = this.allOrgId;
      } else {
        params.parentOrgId = userInfos.orgId;
      }
      console.log(params);
      this.$http
        .getAction(this.$api.findChildOrgByParentOrgId, params)
        .then((res) => {
          if (res.meta.success) {
            let datas = res.data || [];
            this.orgSelect = datas || [];
            if (datas.length) {
              this.$set(this.queryParam, "orgId", datas[0]["orgId"]);
              this.orgName = datas[0]["orgName"];
              this.$nextTick(() => {
                // 获取数据
                if (isRequest) {
                  this.getSetTableList();
                }
              });
            } else {
              setTimeout(() => {
                this.loading = false;
              }, 200);
            }
          } else {
            this.$set(this.queryParam, "orgId", "");
            this.orgSelect = [];
            this.orgName = "";
            setTimeout(() => {
              this.loading = false;
            }, 200);
          }
        })
        .catch(() => {
          this.$set(this.queryParam, "orgId", "");
          this.orgSelect = [];
          this.orgName = "";
          setTimeout(() => {
            this.loading = false;
          }, 200);
        });
    },
    getAllOrgids() {
      let userInfo = this.getItem("wlwUserInfo") || {};
      let userInfos = JSON.parse(userInfo);
      let params = {
        parentOrgId: userInfos.orgId,
        type: "2",
      };
      this.$http
        .getAction(this.$api.findChildOrgByParentOrgId, params)
        .then((res) => {
          if (res.meta.success) {
            let datas = res.data || [];
            this.orgAllSelect = datas || [];
            if (datas.length) {
              this.allOrgId = datas[0]["orgId"];
              this.getOrgids(true);
            } else {
              setTimeout(() => {
                this.loading = false;
              }, 200);
            }

            console.log(datas.length);
          } else {
            this.orgSelect = [];
            this.orgAllSelect = [];
            this.allOrgId = "";
            // 设备清空
            this.$set(this.queryParam, "orgId", "");
            this.$set(this.queryParam, "taskName", "");
            this.orgName = "";
            setTimeout(() => {
              this.loading = false;
            }, 200);
          }
        })
        .catch(() => {
          this.orgSelect = [];
          this.orgAllSelect = [];
          this.allOrgId = "";
          // 设备清空
          this.$set(this.queryParam, "orgId", "");
          this.$set(this.queryParam, "taskName", "");
          this.orgName = "";
          setTimeout(() => {
            this.loading = false;
          }, 200);
        });
    },
    // 分公司网点下拉选选择
    changeAllOrg(val) {
      this.allOrgId = val;
      this.$set(this.queryParam, "orgId", "");
      this.$set(this.queryParam, "taskName", "");
      this.orgName = "";
      this.getOrgids(true, false);
    },
    changeOrg(val) {
      this.$set(this.queryParam, "taskName", "");
      let orgIndex = this.orgSelect.findIndex((item) => {
        return item.orgId == val;
      });
      if (orgIndex > -1) {
        this.orgName = this.orgSelect[orgIndex]["orgName"];
      } else {
        this.orgName = "";
      }
    },
    // 获取任务操作列表
    getSetTableList(arg) {
      if (arg === 1) {
        this.ipagination.currentPage = 1;
      }
      let otherParam = {
        orgCode: "",
      };
      let params = Object.assign({}, this.getQueryParams(), otherParam);
      if (!this.queryParam.taskName || this.queryParam.taskName == "") {
        this.$set(params, "taskName", "");
      }
      if (!this.queryParam.orgId || this.queryParam.orgId == "") {
        // 如果是分公司，没有值的情况下赋值上一级的网点
        if (this.isShowAllSelect) {
          let orgIndex = this.orgAllSelect.findIndex((item) => {
            return item.orgId == this.allOrgId;
          });
          if (orgIndex > -1) {
            this.$set(params, "orgId", this.orgAllSelect[orgIndex]["orgId"]);
          } else {
            this.$set(params, "orgId", "");
          }
        }
      }
      if (this.isShowAllSelect) {
        this.$set(params, "orgCode", this.allOrgId);
      } else {
        let userInfo = this.getItem("wlwUserInfo") || {};
        let userInfos = JSON.parse(userInfo);
        this.$set(params, "orgCode", userInfos.orgId);
      }

      console.log(params);
      this.$http
        .postAction(this.url.taskList, params)
        .then((res) => {
          if (res.meta.success) {
            let result = res.data || {};
            if (result.total > 0) {
              let datas = result.records || [];
              this.tableData = datas || [];
              this.ipagination.total = Number(result.total);
              this.ipagination.pageSize = Number(result.size);
            } else {
              this.tableData = [];
              this.ipagination.total = 0;
              this.ipagination.pageSize = 10;
            }
          } else {
            this.tableData = [];
            this.ipagination.total = 0;
            this.ipagination.pageSize = 10;
          }
        })
        .finally((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    // 获取历史记录列表
    getHisTableList(arg) {
      if (arg === 1) {
        this.ipagination.currentPage = 1;
      }
      let params = this.getQueryParams();
      if (!this.queryParam.taskName || this.queryParam.taskName == "") {
        this.$set(params, "taskName", "");
      }
      this.$set(params, "orgName", this.orgName);
      this.$http
        .postAction(this.url.hisList, params)
        .then((res) => {
          if (res.meta.success) {
            let result = res.data || {};
            if (result.total > 0) {
              let datas = result.records || [];
              this.tableData = datas || [];
              this.ipagination.total = Number(result.total);
              this.ipagination.pageSize = Number(result.size);
            } else {
              this.tableData = [];
              this.ipagination.total = 0;
              this.ipagination.pageSize = 10;
            }
          } else {
            this.tableData = [];
            this.ipagination.total = 0;
            this.ipagination.pageSize = 10;
          }
        })
        .finally((err) => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    // 分页的页码改变
    handleCurrentChange(val) {
      this.ipagination.currentPage = val;
      // 重新加载数据
      if (this.tabIndex == 0) {
        this.getSetTableList();
      } else {
        this.getHisTableList();
      }
    },
    // tab切换
    changeTab(ind) {
      if (this.tabIndex == ind) return;
      this.tabIndex = ind;

      // 重新加载数据
      if (this.tabIndex == 0) {
        this.getSetTableList(1);
      } else {
        this.getHisTableList(1);
      }
    },
    // 查询按钮点击
    searchClick() {
      console.log(this.queryParam);
      this.$refs["ruleform"].validate((valid) => {
        if (valid) {
          // 重新加载数据
          if (this.tabIndex == 0) {
            this.getSetTableList(1);
          } else {
            this.getHisTableList(1);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 点击完成
    handleEnd(row) {
      this.$confirm("确定设置为完成吗？", "操作", {
        confirmButtonText: "确定",
        cancelButtonText: "再想想",
        customClass: "del-dialog",
        cancelButtonClass: "btn-cancel",
        confirmButtonClass: "btn-confirm",
      })
        .then(() => {
          this.endData(row);
          // this.$message('操作成功', 'success')
        })
        .catch(() => {
          // this.$message('已取消删除', 'info')
        });
    },
    // 点击取消
    handleCancel(rows) {
      this.$confirm("确定取消该条操作吗？", "操作", {
        confirmButtonText: "确定",
        cancelButtonText: "再想想",
        customClass: "del-dialog",
        cancelButtonClass: "btn-cancel",
        confirmButtonClass: "btn-confirm",
      })
        .then(() => {
          this.cancelData(rows);
          // // TODO 请求删除接口
          // const newData = this.tableData.filter((item) => item.ids !== rows.ids)
          // this.tableData = newData
          // this.$message('操作成功', 'success')
        })
        .catch(() => {
          // this.$message('已取消删除', 'info')
        });
    },
    // TODO 需根据字段判断列表是否可进行操作
    async endData({ id, planStartTime, planEndTime }) {
      let params = {
        id: id,
        orgId: this.queryParam.orgId,
        state: "0", // 0 完成 1 取消
      };
      await this.$http
        .postAction(this.$api.taslSetPath, params)
        .then((res) => {
          if (res.meta.success) {
            this.getSetTableList(1);
            this.$message("操作成功", "success");
          } else {
            this.$message("操作失败，请稍后重试", "error");
          }
        })
        .catch(() => {
          this.$message("操作失败，请稍后重试", "error");
        });
    },
    async cancelData({ id }) {
      let params = {
        id: id,
        orgId: this.queryParam.orgId,
        state: "1", // 0 完成 1 取消
      };
      await this.$http
        .postAction(this.$api.taslSetPath, params)
        .then((res) => {
          if (res.meta.success) {
            this.getSetTableList(1);
            this.$message("操作成功", "success");
          } else {
            this.$message("操作失败，请稍后重试", "error");
          }
        })
        .catch(() => {
          this.$message("操作失败，请稍后重试", "error");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1585px) {
  .warnform-inline {
    .form-inputs {
      .el-form-item {
        &:not(:last-child) {
          margin-right: 2vw;
        }
        &.form-item-had {
          margin-right: 2vw;
        }
      }
      .el-select {
        width: 2.5rem;
      }
    }
  }
}
@media screen and (max-width: 1370px) {
  .warnform-inline {
    .form-inputs {
      .el-form-item {
        &:not(:last-child) {
          margin-right: 1vw;
        }
        &.form-item-had {
          margin-right: 1vw;
          .el-select {
            width: 2.3rem;
          }
        }
      }
    }
  }
}
.task-page {
  height: 100%;
  .warn-tables {
    padding-top: 0.25rem;
    padding-bottom: 0.15rem;

    flex: 1;
    min-height: 610px;
    .tables {
      // 单元格
      .table-cell {
        color: #666666;
        font-size: 0.17rem;
      }
    }
  }
  // 列表切换tab
  .btn-switchs {
    text-align: center;
    width: 2.5rem;

    background: #ffffff;
    border: 1px solid #2daea9;
    border-radius: 0.13rem;
    position: relative;
    margin: 0 0 0.25rem 0.5rem;
    .btn-switch-btn {
      width: 50%;
      display: inline-block;
      height: 0.4rem;
      line-height: 0.4rem;
      font-size: 0.17rem;
      color: #2daea9;
      position: relative;
      z-index: 5;
      cursor: pointer;
      transition: color 0.5s;
    }
    .btn-switch-active {
      color: #ffffff;
    }
    // 背景颜色
    .bgs {
      width: 50%;
      height: 100%;
      background: #2daea9;
      border-radius: 0.1rem;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 4;
      transition: left 0.5s;
    }
  }
  // 表格中的样式
  .tables {
    .table-edit {
      font-size: 0.17rem;
      color: #2daea9;
      cursor: pointer;
    }
    .table-del {
      font-size: 0.17rem;
      color: #e33434;
      margin-left: 0.3rem;
      cursor: pointer;
    }
  }
  .pagination {
    padding-top: 0;
  }
}
</style>
<style lang="scss">
@import "@/assets/css/del_dialog.scss";
.task-page {
  .warn-tables {
    .tables {
      // 单元格
      .table-cell {
        // height: 0.2rem !important;

        color: #666666;
        font-size: 0.17rem;
      }
    }
  }
}
</style>
